import React, { useState } from "react";
import { ButtonBase } from "@reusejs/react";
import MailSvg from "../../Icons/MailSvg";
import ManualVerification from "./ManualVerification";
import VerificationSuccess from "./VerificationSuccess";
import { useSelector, useDispatch } from "react-redux";
import { requestVerification, verifyRegistration } from "services";
import { setTempToken } from "store";
import Link from "next/link";

export default function Verify() {
  const dispatch = useDispatch();
  const [manual, setManual] = useState(false);
  const [verified, setVerified] = useState(false);
  const guestUser = useSelector((state: any) => {
    return state.auth.guestUser;
  });

  const handleManualVerification = async (payload: any) => {
    try {
      await verifyRegistration(payload).then((res) => {
        dispatch(setTempToken(res));
        setVerified(true);
      });
    } catch (error) {
      console.log("check here error", error);
      setVerified(false);
    }
  };

  const handleResendCode = async (payload: any) => {
    try {
      await requestVerification(payload);
    } catch (error) {
      console.log("check here error", error);
    }
  };

  return !verified ? (
    <div className="px-4 sm:px-6 lg:px-20 xl:px-24 flex">
      <div className="mx-auto w-full max-w-md lg:w-96 ">
        <div>
          <div className="flex justify-center lg:justify-start">
            <MailSvg />
          </div>
          <h2 className="text-center lg:text-left mt-6 text-3xl font-semibold text-gray-900 tracking-tight">
            Check your email
          </h2>
          <p className="text-center lg:text-left mt-3 text-base text-gray-600">
            We sent a verification link to
          </p>
          <p className="text-center lg:text-left text-base font-medium text-blue-700 hover:text-blue-600">
            {guestUser?.email ? guestUser.email : ""}
          </p>

          <div className="mt-4">
            {manual ? (
              <ManualVerification
                handleManualVerification={handleManualVerification}
                handleResendCode={handleResendCode}
              />
            ) : (
              <ButtonBase
                variant="primary"
                type="submit"
                label="Enter code manually"
                onClick={() => {
                  setManual(true);
                }}
                buttonBaseClasses={{
                  font: "text-sm font-medium",
                  backgroundColor: "bg-blue-600 hover:bg-blue-700",
                  textColor: "text-white",
                  border: "any",
                  width: "w-full",
                  padding: "px-4 py-3",
                }}
              />
            )}
          </div>
          <div className="py-5 bg-blue-gray-50">
            <Link href="/login">
              <a className="text-sm font-medium text-gray-500 hover:text-blue-700">
                <span aria-hidden="true">&larr; </span>Back to log in
              </a>
            </Link>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <VerificationSuccess />
  );
}
